
import api from '../../api/api.js'
import processed from '../../api/moudles/processed'
import utils from '../../utils/utils.js'
import lazadaorders from '../../api/moudles/lazadaorders.js'
import { Message } from 'element-ui'
import Base64  from 'js-base64'
import router from '../../router/index.js'



import {
    GET_ORDER_LIST,
	GET_ORDER_LIST_UNPROCESSED,
	GET_ORDER_LIST_SHIPPED,
	GET_ORDER_LIST_PROBLEM,
	GET_ORDER_LIST_PENDING,
	SET_LAZADA_STATE_NULL,
	GET_LAZADA_LIST
  
} from '../mutation-types'

const state = () => ({
	lazadaorderlist:[],//lazada全部店铺订单
	lazadaorderlistCount:0,
	pendingOrderList:[],
	pendingOrderTotal:0,
	unprocessedOrderList:[],
	unprocessedOrderTotal:0,
	shippedorderList:[],
	shippOrderTotal:0,
	problemOrderList:[],
	problemOrderTotal:0,
	auditOrder_success:[],
	auditOrder_error:[],
	shipment:[],
	orderList:[],
	buttonList:[],
	activeList:[],
	buttonMapList:[],
	aleadyGenaratedNum:[],
	logisticsInfo:[{
		Id:'',
		Name:'全部'
	}],
	amountList:[],
	falg:false,
	tableList:[],
	refreshBtn:false,
	amountListCount:0,
   
})

const getters = {}

const actions = {
	
	//仓库获取所有已处理的订单
		getProcessedOrderByStorelazada({state,dispatch}, payload) {
			lazadaorders
				.getProcessedOrderByStorelazada(payload)
				.then(res => {
					if (res.code === 200) {
						console.log('仓库获取所有已处理的订单',res.data)
						state.tableList=res.data
						state.falg=true 
						setTimeout(() => {
							state.falg=false
						})
					}
				})
		},
	
	
	//仓库获取所有物流方式
		getLogisticsBystorelazada({state,dispatch}, payload) {
			lazadaorders
				.getLogisticsBystorelazada(payload)
				.then(res => {
					if (res.code === 200) {
						console.log('仓库获取所有物流方式',res.data)
						state.logisticsInfo=[{
									Id:'',
									Name:'全部'
								}]
						
						res.data.forEach((p,index) => {
							if(p.logistics){
								state.logisticsInfo.push({
									Id:p.logistics,
									Name:p.logistics
								})
								
							}
						})
						
						console.log(state.logisticsInfo)
					}
				})
		},
	
	
	//仓库获取一段时间内打包的订单数量
		getProcessedOrdersByStorelazada({state,dispatch}, payload) {
			lazadaorders
				.getProcessedOrdersByStorelazada(payload)
				.then(res => {
					if (res.code === 200) {
						console.log('仓库获取一段时间内打包的订单数量',res.data)
						
						console.log('仓库获取一段时间内打包的订单数量',)
					}
				})
		},
		//卖家获取所有已处理的订单
		getProcessedOrderBySellerLazada({state,dispatch}, payload) {
			lazadaorders
				.getProcessedOrderBySellerLazada(payload)
				.then(res => {
					if (res.code === 200) {
						console.log('卖家获取所有已处理的订单',res.data)
						state.tableList=res.data
						state.falg=true 
						setTimeout(() => {
							state.falg=false
						})
					}
				})
		},
	
		//卖家获取所有物流方式
		getLogisticsBysellerLazada({state,dispatch}, payload) {
			lazadaorders
				.getLogisticsBysellerLazada(payload)
				.then(res => {
					if (res.code === 200) {
						console.log('卖家获取所有物流方式',res.data)
						state.logisticsInfo=[{
									Id:'',
									Name:'全部'
								}]
						res.data.forEach((p,index) => {
							if(p.logistics){
								state.logisticsInfo.push({
									Id:p.logistics,
									Name:p.logistics
								})
								
								
							}
						})
						
						console.log(state.logisticsInfo)
					}
				})
		},
		//卖家获取一段时间内打包的订单数量
		getProcessedOrdersLazada({state,dispatch}, payload) {
			lazadaorders
			.getProcessedOrdersLazada(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('卖家获取一段时间内打包的订单数量',res.data)
					state.amountList=res.data.orders
					state.amountListCount=res.data.count
					}
				})
		},

	//获取lazada待审核的订单 ---高级查询页面
	getUnAuditOrders({state,commit},payload){
		lazadaorders
		.getUnAuditOrders(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('获取lazada待审核的订单高级查询',res.data)
				state.orderList=res.data
				
				state.buttonList = [];
				for (let i = 0; i < 3; i++) {
					state.buttonList.push(new Map())
					state.activeList.push('all')
				}
				//选择店铺
				state.orderList.forEach((order) => {
					order.checked=false
					order.shipByDateCopy=order.shipByDate
					order.flagInfo={flagId:order.flagId,desc:null}
					order.shipByDate=utils.renderTimeDate(order.shipByDate)
					
					let shopIdMap = state.buttonList[0];
					let shopIdList = shopIdMap.get(order.shopId);
					if (shopIdList == null || shopIdList == "undifined") {
						shopIdList = [];
					}
					shopIdList.push(order);
					shopIdMap.set(order.shopId, shopIdList)
					state.buttonList[0] = shopIdMap;
				})
								
				
				let list = [];
				let flag = true;
				let firstShopId=0;
				state.buttonList[0].forEach((value, key) => {
					if(firstShopId==0){
						firstShopId=key
					}
					let active = (key == firstShopId)
					if (active == true) {
						flag = false
					}
					list.push({
						'key': key,
						'value': value,
						'isActive': active
					})
				})
				if (flag) {
					list[0].isActive = true;
				}
				state.buttonMapList.push(list);
				console.log('asfdsafga', state.buttonList);
				console.log('asfdsafga', state.buttonMapList);
				
				commit(GET_LAZADA_LIST,{
					orders: state.buttonList[0].get(firstShopId),
					index: 0
				})
				
				
			}
		})
	},
	
	// 获取lazada各种状态的订单
	getLazadaOrderByuserid({commit,state},payload){
		lazadaorders
		.getLazadaOrderByuserid(payload)
		.then(res => {
			if(res.code === 200) {
			
				res.data.orders.forEach(p => {
					p.checked=false
				})
				if(payload.type === 2){
					console.log('LAzada待处理订单',res.data)
					commit(GET_ORDER_LIST_UNPROCESSED,res.data)
				}else if(payload.type === 3){
					console.log('LAzada待生成订单',res.data)
					commit(GET_ORDER_LIST_UNPROCESSED,res.data)
				}else if(payload.type === 4){
					console.log('LAzada待打印订单',res.data)
					commit(GET_ORDER_LIST_UNPROCESSED,res.data)
				}else if(payload.type === 5){
					console.log('LAzada已打印订单',res.data)
					commit(GET_ORDER_LIST_UNPROCESSED,res.data)
				}else if(payload.type === 6){
					console.log('LAzada已处理的全部订单',res.data)
					commit(GET_ORDER_LIST_SHIPPED,res.data)
				}else if(payload.type === 7){
					console.log('LAzada已发货订单',res.data)
					commit(GET_ORDER_LIST_SHIPPED,res.data)
				}else if(payload.type === 8){
					console.log('LAzada已送达订单',res.data)
					commit(GET_ORDER_LIST_SHIPPED,res.data)
				}else if(payload.type === 9){
					console.log('LAzada全部问题单',res.data)
					commit(GET_ORDER_LIST_PROBLEM,res.data)
				}else if(payload.type === 10){
					console.log('LAzada问题单-退货单',res.data)
					commit(GET_ORDER_LIST_PROBLEM,res.data)
				}else if(payload.type === 11){
					console.log('LAzada问题单-派送失败',res.data)
					commit(GET_ORDER_LIST_PROBLEM,res.data)
				}else if(payload.type === 12){
					console.log('LAzada问题单-取消单',res.data)
					commit(GET_ORDER_LIST_PROBLEM,res.data)
				}else if(payload.type === 0){
					console.log('lazada全部订单',res.data)
					commit(GET_ORDER_LIST,res.data)
				}else if(payload.type === 1) {
					console.log('lazada待审核订单',res.data)
					commit(GET_ORDER_LIST_PENDING,res.data)
				}
			}else if(res.code === 500) {
				console.log(123)
				state.unprocessedOrderList=[]
			}
		})
	},
	
	//库存允许内审核多个订单
	auditLazadaOrdersByStockRule({state},payload){
		lazadaorders
		.auditLazadaOrdersByStockRule(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('审核多个订单结果',res.data)
				state.auditOrder_success=res.data.success
				state.auditOrder_error=res.data.error
			}
		})
	},
	
	
	//获取物流方式
	getLogistics({state},payload){
		lazadaorders
		.getLogistics(payload)
		.then(res => {
			if(res.code === 200) {
				let data=JSON.parse(res.data)
				console.log('物流方式',data)
				
				state.shipment=data.data.shipment_providers.map(p => {
					return {
						name:p.name
					}
				})
			}
		})
	},
	
	//生成运单号
	getTrickingNo({state},payload){
		lazadaorders
		.getTrickingNo(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('生成的运单号',res.data)
				if(res.data){
					state.aleadyGenaratedNum.push(res.data)
				}
				// state.unprocessedOrderList.forEach(p => {
				// 	if(p.orderId === res.data.orderId) {
				// 		p.items.forEach(k => {
				// 			console.log(555)
				// 			k.trackingCode=res.data.trackingCode
				// 		})
				// 	}
				// })
			}
		})
	},
	//同步最新的订单
	Synchronizeorders({state},payload){
		lazadaorders
		.Synchronizeorders(payload)
		.then(res => {
			if(res.code === 200) {
				// Message({
				// 	message: '订单已同步到最新状态，请一段时间后刷新页面！',
				// 	type: 'success'
				// })
			}
		})
	},
	
	//全部审核通过
	reviewAllorders({state},payload){
		lazadaorders
		.reviewAllorders(payload)
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '审核成功！',
					type: 'success'
				})
				
				for(let i=0;i<payload.length;i++){
					
					state.buttonMapList[0].forEach((j,index) => {
						if(j.isActive){
							j.value.forEach((p,index) => {
								payload.forEach(k => {
									if(p.orderId === k.ordersn){
										j.value.splice(index,1)
									}
								})
							})
						}
					})
				}
				
				state.refreshBtn=true
				setTimeout(() => {
					state.refreshBtn=false
				},500)
			}
		})
	},
	//审核一部分的订单
	reviewSomeorders({state},payload){
		lazadaorders
		.reviewSomeorders(payload)
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '审核成功！',
					type: 'success'
				})
				
		        for(let i=0;i<payload.length;i++){
					
					state.buttonMapList[0].forEach((j,index) => {
						if(j.isActive){
							j.value.forEach((p,index) => {
								payload.forEach(k => {
									if(p.orderId === k.ordersn){
										j.value.splice(index,1)
									}
								})
							})
						}
					})
				}
				
				state.refreshBtn=true
				setTimeout(() => {
					state.refreshBtn=false
				},500)
						
			}
		})
	},
	
	//批量取消审核
	cancelReives({state},payload){
		lazadaorders
		.cancelReives(payload)
		.then(res => {
			if(res.code === 200) {
				console.log(payload)
				Message({
					message: '订单已重置为待审核状态！',
					type: 'success'
				})
				
				for (var i = 0; i < payload.length; i++) {
				  for (var j = 0; j < state.unprocessedOrderList.length; j++) {
					if (payload[i].ordersn === state.unprocessedOrderList[j].orderId) {
						console.log(8888)
					  state.unprocessedOrderList.splice(j,1)
					  break;
					}
				  }
				}	
			}
		})
	},
	
	//打印订单
	printOrderlazada({state},payload){
		const p=new Promise((resolve) => {
			lazadaorders
			.printOrderlazada(payload)
			.then(res => {
				let Base64 = require('js-base64').Base64
				if(res.code === 200) {
					console.log('lazadaUrl',res.data)
					resolve(res.data)
					// let file=JSON.parse(res.data.urls[0].url).data.document.file
					// let newfile=Base64.decode(file)
					// localStorage.removeItem('alipay')
					// localStorage.setItem('html',newfile)
					// let newUrl=location.host + '/sealpage'
					// console.log(newUrl)
					// window.open('https://' + newUrl)
					
				}else{
					Message({
						message: res.msg,
						type: 'warning'
					})
				}
			})
		})

		return p
		
	},
	
	//根据订单号查找订单
	lookupOrderbyOrder({commit},payload){
		lazadaorders
		.lookupOrderbyOrder(payload)
		.then(res => {
			if(res.code === 200) {
				console.log(res.data)
				if(payload.type === 2) {
					console.log(222)
				  commit(GET_ORDER_LIST_PENDING,res.data)
				}else if(payload.type === 3) {
					commit(GET_ORDER_LIST_UNPROCESSED,res.data)
				}
				
			}
		})
	},
}

const mutations = {
	[GET_ORDER_LIST]:(state,data) =>{
		state.lazadaorderlist=data.orders
		state.lazadaorderlistCount=data.count
	},
	[GET_ORDER_LIST_PENDING]:(state,data) =>{
		state.pendingOrderList=data.orders
		state.pendingOrderTotal=data.count
	},
	[GET_ORDER_LIST_UNPROCESSED]:(state,data) =>{
		state.unprocessedOrderList=data.orders
		state.unprocessedOrderTotal=data.count
	},
	[GET_ORDER_LIST_SHIPPED]:(state,data) =>{
		state.shippedorderList=data.orders
		state.shippOrderTotal=data.count
	},
	[GET_ORDER_LIST_PROBLEM]:(state,data) =>{
		state.problemOrderList=data.orders
		state.problemOrderTotal=data.count
	},
	[SET_LAZADA_STATE_NULL]:(state) =>{
		state.auditOrder_success=[]
		state.auditOrder_error=[]
	},
	//筛选订单类型
	[GET_LAZADA_LIST]: (state, data) => {
		let index = data.index
		let orderList = [];
		if (index > 0) {
			orderList = state.buttonList[index].get(data.orders)
			
		} else {
			orderList = data.orders
		}
		
		for (let i = index + 1; i < 3; i++) {
			state.buttonList[i] = new Map();
			if (i > 0) {
				state.buttonList[i].set("all", orderList)
			}
		}
		console.log(orderList)
		if(orderList !== undefined){
			orderList.forEach((order) => {
				
				//最后发货
				if (index < 1) {
					let shipbydateMap = state.buttonList[1]
					let shipbydateList = shipbydateMap.get(order.shipByDate)
					if (shipbydateList == null || shipbydateList == "undifined") {
						shipbydateList = [];
					}
					shipbydateList.push(order);
					shipbydateMap.set(order.shipByDate, shipbydateList)
					
					state.buttonList[1] = shipbydateMap;
					
				}
			
				
			
				//sku状态
				if (index < 2) {
					let skuQuantityMap = state.buttonList[2]
					let skuQuantityList = skuQuantityMap.get(order.itemNum == 1 ? "oneSku" : "someSku")
					if (skuQuantityList == null || skuQuantityList == "undifined") {
						skuQuantityList = [];
					}
					skuQuantityList.push(order);
					skuQuantityMap.set(order.itemNum == 1 ? "oneSku" : "someSku", skuQuantityList)
					state.buttonList[2] = skuQuantityMap;
				}
			
			
			})
			
			for (let j = 1; j < 3; j++) {
				state.buttonMapList[j] = null
			}
			state.buttonMapList.length = 1
			
			state.buttonList.forEach((map, i) => {
				let list = [];
				let flag = true;
				if (i != 0 ) {
					map.forEach((value, key) => {
						let active = (key == state.activeList[i])
						if (active == true) {
							flag = false
						}
						list.push({
							'key': key,
							'value': value,
							'isActive': active
						})
					})
					if (flag) {
						list[0].isActive = true;
					}
					state.buttonMapList.push(list);
				}
			
			})
			
			console.log('adcvrfasdasbtr', state.buttonMapList);
			console.log('adcvrfasdasbtr', state.buttonMapList);
			console.log('adcvrfbtr', state.buttonList);
		}else{
			state.buttonMapList.forEach((p,index) => {
				if(index >2){
					p=[{
						isActive:true,
						key:"all",
						value:[]
					}]
				}
			})
			}
		}

} 

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}